import React from "react";

import todayOrYesterday from "Libs/datetime";
import RoundLegend from "src/organization/pages/project/environment/metrics/http2/components/RoundLegend";

import { severityToColor } from "../components/utils";
import { LogOverviewPoint, severityLevels } from "../types";

import * as S from "./LogsOverview.styles";

type TooltipLogSummaryProps = {
  point: LogOverviewPoint;
};

function TooltipLogSummary({ point }: TooltipLogSummaryProps) {
  return (
    <div>
      <S.TooltipTitle>{todayOrYesterday(point.timestampDate)}</S.TooltipTitle>
      <S.LogCounter>
        <S.FlexPrimary>
          <div style={{ marginLeft: 12 }}>
            {point.total} <S.Bold>Total</S.Bold>
          </div>
        </S.FlexPrimary>
        {severityLevels
          .filter(sl => point[sl] > 0)
          .map(sl => (
            <S.Flex key={sl}>
              <RoundLegend color={severityToColor(sl)} />
              <div>
                <S.Bold>{point[sl]}</S.Bold> {sl.toLowerCase()}
              </div>
            </S.Flex>
          ))}
      </S.LogCounter>
    </div>
  );
}

export default TooltipLogSummary;
